// extracted by mini-css-extract-plugin
module.exports = {"accordion-body":"accordion-body--8g1ck","accordion-body--expanded":"accordion-body--expanded--8g1ck","accordion-body__wrapper":"accordion-body__wrapper--8g1ck"};